import angular from 'angular';

const DIRECTIVE_NAME = 'inView';
const SUPPORTS_OBSERVER = ('IntersectionObserver' in window);

angular.module('vrm.components')
    .directive(DIRECTIVE_NAME, inViewportDirective);

/* @ngInject */
function inViewportDirective($parse) {
    if (SUPPORTS_OBSERVER) {
        return {
            restrict: 'A',
            link: (scope, element, attrs) => {
                const inViewExpression = $parse(attrs[DIRECTIVE_NAME]);
                const observer = new IntersectionObserver((entries) => {
                    scope.$applyAsync(() => {
                        let intersecting = false;
                        angular.forEach(entries,(entry) => {
                            intersecting = intersecting || entry.isIntersecting;
                        });
                        inViewExpression(scope, {
                            $inview: intersecting
                        });
                    });
                });
                observer.observe(element[0]);
                scope.$on('$destroy', function() {
                    observer && observer.disconnect();
                });
            },
        };
    } else {
        return {
            restrict: 'A',
            link: (scope, element, attrs) => {
                const inViewExpression = $parse(attrs[DIRECTIVE_NAME]);
                inViewExpression(scope, {$inview: true});
            },
        };
    }
}
